import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthClient } from '../auth/auth.client';
import { Subject, Subscription } from 'rxjs';

@Injectable()
export class CanActivateInSessionGuard implements CanActivate {
  
  constructor(
    private _authClient: AuthClient,
    private _router: Router) {}

  canActivate() {
    return this._authClient.isAuthenticatedAsync().map((isAuthenticated) => {
      if(isAuthenticated) {
        this._router.navigate(['mc']);
      }

      return !isAuthenticated;
    });
  }
}
